import {
  Companion_getInstance21oyq66lfgb66 as Companion_getInstance,
  MarkdownContent25fmztzs0fh3a as MarkdownContent,
} from '../../../../../../Coupling-client-components/com/zegreatrob/coupling/client/components/MarkdownContent.mjs';
import com_zegreatrob_coupling_client_components_connectSuccessMd_dqyjbs from '/com/zegreatrob/coupling/client/ConnectSuccess.md?raw';
import com_zegreatrob_coupling_client_components_contributionStartMd_4ae08v from '/com/zegreatrob/coupling/client/ContributionStart.md?raw';
import com_zegreatrob_coupling_client_components_boostMd_y2kbqq from '/com/zegreatrob/coupling/client/Boost.md?raw';
import com_zegreatrob_coupling_client_components_recentInfoMd_k3i20o from '/com/zegreatrob/coupling/client/recent-info.md?raw';
import com_zegreatrob_coupling_client_components_aboutMd_d8m8d8 from '/com/zegreatrob/coupling/client/About.md?raw';
import com_zegreatrob_coupling_client_components_installSuccessMd_rm0sah from '/com/zegreatrob/coupling/client/InstallSuccess.md?raw';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function loadMarkdown() {
  var tmp = Companion_getInstance();
  var tmp0_connectSuccessMd = com_zegreatrob_coupling_client_components_connectSuccessMd_dqyjbs;
  var tmp1_contributionStartMd = com_zegreatrob_coupling_client_components_contributionStartMd_4ae08v;
  var tmp2_boostMd = com_zegreatrob_coupling_client_components_boostMd_y2kbqq;
  var tmp3_recentInfoMd = com_zegreatrob_coupling_client_components_recentInfoMd_k3i20o;
  var tmp4_aboutMd = com_zegreatrob_coupling_client_components_aboutMd_d8m8d8;
  var tmp5_installSuccessMd = com_zegreatrob_coupling_client_components_installSuccessMd_rm0sah;
  tmp.content_1 = new (MarkdownContent())(tmp4_aboutMd, tmp0_connectSuccessMd, tmp1_contributionStartMd, tmp2_boostMd, tmp3_recentInfoMd, tmp5_installSuccessMd);
}
//region block: exports
export {
  loadMarkdown as loadMarkdown2slzyuwbneozg,
};
//endregion

//# sourceMappingURL=MarkdownPaths.mjs.map
